import { useKeycloak } from '@react-keycloak/web';

import React, { useEffect, useState } from 'react';
import { BrowserRouter, Route, Switch, HashRouter } from 'react-router-dom';

//import Menu from '../components/Menu';
//import HomePage from '../pages/HomePage';
import { PrivateRoute } from './utils/PrivateRoute';
//import ProtectedPage from '../pages/ProtectedPage';
import { TheLayout } from './containers';
//import Login from './views/pages/login/Login';
import Loading from './components/Loading/Loading';
import { AuthProvider } from './context/auth'
const Login = React.lazy(() => import('./views/pages/login/Login'));

//const TheLayout = React.lazy(() => import('./containers/TheLayout'));

const AppRouter = () => {
    const { keycloak, initialized } = useKeycloak();
    const [userInfo, setUserInfo] = useState();

    //console.log("Keycloak State:", { initialized, authenticated: keycloak?.authenticated });

    useEffect(() => {
        if (initialized && keycloak.authenticated) {
            keycloak.loadUserProfile().then(profile => {
                const token = keycloak.idTokenParsed || {};
                console.log("ID Token Parsed:", keycloak.idTokenParsed);
                console.log("Profile:", profile);
                setUserInfo({
                    username: profile.username,
                    clientID: token.clientIDAttr || 'N/A',
                    userID: token.userIDAttr || 'N/A',
                });
            });
        }
    }, [initialized, keycloak.authenticated]);

    if (!initialized) return <div>Inicializando Autenticação...</div>;
    if (initialized && !keycloak.authenticated) {
        keycloak.login(); // <- Força o login apenas uma vez
        return <div>Redirecionando para login...</div>;
    }

    //if (!userInfo) return <div>Carregando perfil...</div>;

    return (
        <AuthProvider>
            <BrowserRouter>
                <React.Suspense fallback={<div>Carregando...</div>}>
                    <Switch>
                        <PrivateRoute
                            roles={['default-roles-alpha manager']}
                            path="/"
                            name="Home"
                            component={props => <TheLayout {...props} />}
                        />
                    </Switch>
                </React.Suspense>
            </BrowserRouter>
        </AuthProvider>
    );
};


export default AppRouter;